var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","top":"0","left":"0","z-index":"10"}},[_c('canvas',{style:(_vm.psdStyle),attrs:{"id":"psdCanvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }